import _get from 'lodash/get';
import {
  GET_ZIPCODE_FULFILLED, GET_ZIPCODE_FAILED, CLEAR_ZIPCODE, CHANGE_ZIPCODE,
  SEARCH_BY_ZIPCODE_PENDING, SEARCH_BY_ZIPCODE_FULFILLED,
  INVALIDATE_ZIPCODE,
} from '../actions/actionTypes';
// import { CREATE_PARAMS } from '../constants/searchParams';
// import { DESIGNSESSION_CLEAR } from '../constants/designBuilderConstants';

// Must be a pure function that requires the state
// and the action being dispatched.
const initialState = {
  isValid: false,
  errorMessage: null,
  zipcode: '',
  hasAvailableProductsInZipCode: false,
  status: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
  // NEVER mutate the state, always return a new state.
  // case DESIGNSESSION_CLEAR: {
  //   return {
  //     ...initialState,
  //   };
  // }

  // case CREATE_PARAMS: {
  //   return {
  //     ...state,
  //     isValid: true,
  //     errorMessage: null,
  //     zipcode: action.zipCode,
  //   };
  // }

  case GET_ZIPCODE_FULFILLED: {
    const zipcodeResult = _get(action.payload, 'CityStateLookupResponse[0].ZipCode[0].Zip5[0]._text');

    return {
      ...state,
      isValid: true,
      errorMessage: null,
      zipcode: zipcodeResult,
      status: '',
    };
  }

  case GET_ZIPCODE_FAILED: {
    return {
      ...state,
      isValid: false,
      errorMessage: action.payload.errorMessage,
      zipcode: action.payload.zipcode,
    };
  }

  case CHANGE_ZIPCODE: {
    return {
      ...state,
      zipcode: action.payload.zipcode,
      isValid: !(action.payload.message && action.payload.message.length > 0),
      hasAvailableProductsInZipCode: true,
    };
  }

  case CLEAR_ZIPCODE: {
    return initialState;
  }

  case SEARCH_BY_ZIPCODE_PENDING: {
    return {
      ...state,
      status: 'pending',
      hasAvailableProductsInZipCode: false,
    };
  }

  case SEARCH_BY_ZIPCODE_FULFILLED: {
    const products = action.payload.data.EleanorSiteProductSearch.Products;
    const hasProducts = products && products.length > 0;
    const errorMsg = hasProducts === false ? 'Zip code currently has no products available.' : null;

    return {
      ...state,
      status: 'done',
      hasAvailableProductsInZipCode: hasProducts,
      errorMessage: errorMsg,
    };
  }

  case INVALIDATE_ZIPCODE: {
    return {
      ...state,
      status: '',
      isValid: !(action.payload.message && action.payload.message.length > 0),
      errorMessage: action.payload.message,
      zipcode: action.payload.zipcode,
      hasAvailableProductsInZipCode: false,
    };
  }

  default:
    return state;
  }
};
